import { render, staticRenderFns } from "./SaleInvoicesProfileCard.vue?vue&type=template&id=c1b6ccae&scoped=true&"
import script from "./SaleInvoicesProfileCard.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b6ccae",
  null
  
)

export default component.exports